import { MembershipTeaserPanel } from '@r-and-a-shared-ui/common-ui/src/lib/MembershipTeaserPanel/MembershipTeaserPanel';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { MEMBERSHIP_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
export default {
  component: ()=>MembershipTeaserPanel,
  mapEntryToProps: (entry: MEMBERSHIP_MODELS.MembershipTeaserPanel) =>
    kontentAiDataMapping.membership_teaser_panel(entry),
};
